var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[_vm._t("default",function(){return [_c('SecondaryBtn',_vm._g(_vm._b({attrs:{"href":_vm.mailTo,"color":"info","icon":"forward_to_inbox"}},'SecondaryBtn',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n      Contact support about this\n    ")])]},null,{ mailTo: _vm.mailTo })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }